export default __webpack_public_path__ + "static/media/ivk_vwlt_wer_ist_da.94bc93dd.svg";